module.exports = __webpack_public_path__ + "img/s3_travail.9a9970a4.png";